import { render, staticRenderFns } from "./PlacementsSingleEndComponentCard.vue?vue&type=template&id=e4582dc4&"
import script from "./PlacementsSingleEndComponentCard.vue?vue&type=script&lang=js&"
export * from "./PlacementsSingleEndComponentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports